// this file added by Bearer Web Developer
import React, { useState } from 'react';
import { Button } from '@mui/material';
import styles from './accountForm.module.scss';
import { observer } from 'mobx-react-lite';
import data from './data.json';
import BearerTextField from '../../../../components/fields/BearerTextField';
import { useAppState } from '../../../../states/app-state';
import DisabledClickLoading from '../../../../components/DisabledClickLoading';
import { log } from '../../../../app/log';
import { InviteMethod } from '../../../../states/accountFormConfirmState';
import { useThemeMode } from '../../../../states/contexts/theme';


const AccountForm: React.FC = observer(() => {

    const appState = useAppState();
    const { accountFormConfirm, createAccount } = appState;
    const { setActiveData, inviteMethod, setInviteCode, inviteCode } = accountFormConfirm;
    const [loading, setLoading] = useState<boolean>(false);
    const handleCLick = (data: InviteMethod) => {
        setActiveData(data);
    }
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (checkvalidation()) {
            log({ inviteMethod, inviteCode });
            setLoading(true);
            const resultIp = await accountFormConfirm?.createUserRequestFirebase();
            if (resultIp) {
                const registerResult = await accountFormConfirm?.fetchRegisterBusinessCustomerStepOne(resultIp);
                if (registerResult?.code === 200) {
                    createAccount?.setStep(2);
                }
            }
            setLoading(false);
        }
    }
    function checkvalidation() {
        return !!(inviteMethod && (inviteMethod?.title === "Referral Code" ? inviteCode : true))
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <form onSubmit={handleSubmit} className={styles.account_form} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <ul>
                {data.map((known : InviteMethod, i) => (
                    <li key={i} onClick={() => handleCLick(known)}
                        className={known?.id === inviteMethod?.id ? styles.active : ''}>
                        <div className={styles.circle}>
                            {
                                theme === 'dark' ?       
                                <img src={known?.id === inviteMethod?.id ? known?.src?.black : known?.src?.white}
                                alt={known?.title} width={32} height={32} /> :
                                <img src={known?.id === inviteMethod?.id ? known?.src?.white : known?.src?.grey}
                                    alt={known?.title} width={32} height={32} />
                            }
                        </div>
                        <h5>{known?.title}</h5>
                    </li>
                ))}
            </ul>
            {
                inviteMethod && inviteMethod?.title === "Referral Code" &&
                <div className={styles.input}>
                    <BearerTextField
                        colorStyle="gray"
                        label="Invite Code"
                        placeholder="..."
                        type="text"
                        name="invite-code"
                        value={inviteCode}
                        onChange={(e) => setInviteCode(e.target.value)}
                        clear={() => { setInviteCode('') }}
                    />
                </div>
            }
            <div>
                <Button type='submit' className={styles.button} disabled={!checkvalidation()} disableRipple={true}>
                    <span>Confirm</span>
                </Button>
                {loading && <DisabledClickLoading />}
            </div>
        </form>
    )
});
export default AccountForm;